import { render, staticRenderFns } from "./how-it-works.vue?vue&type=template&id=df53fb78&scoped=true&"
import script from "./how-it-works.vue?vue&type=script&lang=js&"
export * from "./how-it-works.vue?vue&type=script&lang=js&"
import style0 from "./how-it-works.vue?vue&type=style&index=0&id=df53fb78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df53fb78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
